import React from 'react'
import PropTypes from 'prop-types'

const NO_AUTOCORRECT = {
    autoComplete: 'off',
    autoCorrect: 'off',
    spellCheck: 'false',
}


const TextArea = ({ onChange, name, object, validation, placeholder, className = '', type = 'text', onBlur = () => {}, autoCapitalize = 'words', autoCorrect = true, readOnly = false }) => {
    className = validation && validation[name] ? 'form-control text-area-default error ' + className : 'form-control text-area-default ' + className
    const autoCorrectAttributes = autoCorrect ? {} : NO_AUTOCORRECT

    return (
        <textarea
            className={className}
            placeholder={placeholder}
            value={object[name] || ''}
            name={name}
            onBlur={onBlur}
            {...autoCorrectAttributes}
            autoCapitalize={autoCapitalize}
            readOnly={readOnly}
            onChange={event => {
                onChange(name, event.target.value)
            }}/>
    )
}

TextArea.propTypes = {
    onChange: PropTypes.func,
    name: PropTypes.string.isRequired,
    object: PropTypes.object.isRequired,
    validation: PropTypes.object,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    type: PropTypes.string,
    onBlur: PropTypes.func,
    autoCapitalize: PropTypes.string,
    autoCorrect: PropTypes.bool,
}


export default TextArea



// WEBPACK FOOTER //
// ./src/modules/form/component/TextArea.js